// extracted by mini-css-extract-plugin
module.exports = {"text":"BigFiveSuggestionInfo_text__2W6E0"};